module.exports = __webpack_public_path__ + "img/pic_2.de0ce68f.png";